import * as React from "react"

function SvgComponent(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={70.825}
      height={70.877}
      viewBox="0 0 70.825 70.877"
      {...props}
    >
      <path d="M1.384 1.384h52.05v68.108H1.384z" fill="#fff3da" />
      <path d="M38.045 58.6l-1.173 10.892 8.846-6.462z" fill="#8aa8bd" />
      <path
        d="M59.69 21.108l7.673 4.43-21.646 37.49-7.673-4.43z"
        fill="#66dff6"
      />
      <path
        d="M67.364 25.538l-7.673-4.43 1.484-2.571a4.43 4.43 0 117.673 4.43z"
        fill="#ff7d97"
      />
      <g>
        <path d="M41.391 22.426H13.428a1.385 1.385 0 100 2.769h27.963a1.385 1.385 0 100-2.769zM13.428 32.947h9.23a1.385 1.385 0 000-2.769h-9.23a1.385 1.385 0 000 2.769zM41.393 30.178H31.112a1.385 1.385 0 000 2.769h10.281a1.385 1.385 0 000-2.769zM41.391 14.674H13.428a1.385 1.385 0 100 2.769h27.963a1.385 1.385 0 100-2.769zM42.776 39.314a1.384 1.384 0 00-1.385-1.384H13.428a1.385 1.385 0 000 2.769h27.963a1.384 1.384 0 001.385-1.385zM13.428 48.451h7.13a1.385 1.385 0 100-2.769h-7.13a1.385 1.385 0 100 2.769zM36.823 47.066a1.384 1.384 0 00-1.385-1.384h-8.652a1.385 1.385 0 000 2.769h8.652a1.384 1.384 0 001.385-1.385zM13.428 56.204H25.61a1.385 1.385 0 100-2.769H13.428a1.385 1.385 0 100 2.769z" />
        <path d="M67.919 15.717a5.821 5.821 0 00-7.942 2.128l-5.163 8.935v-7.4a1.385 1.385 0 10-2.769 0v12.194l-15.2 26.334a1.384 1.384 0 00-.177.544l-1.04 9.656H2.769V2.769H52.05v4.153a1.385 1.385 0 102.769 0V1.384A1.384 1.384 0 0053.435 0H1.384A1.384 1.384 0 000 1.384v68.109a1.384 1.384 0 001.384 1.384h52.05a1.384 1.384 0 001.38-1.384V50.037L70.048 23.66a5.821 5.821 0 00-2.128-7.942zM45.214 61.139l-5.275-3.045L60.198 23l5.275 3.045zm-6.017-.277l3.991 2.3-4.6 3.361zm27.338-42.747a3.049 3.049 0 011.115 4.16l-.792 1.372-5.275-3.047.792-1.372a3.049 3.049 0 014.16-1.113zM52.05 68.108H41.114l5.421-3.96a1.384 1.384 0 00.382-.426l5.133-8.89z" />
        <path d="M53.434 11.767a1.385 1.385 0 10.979.406 1.393 1.393 0 00-.979-.406z" />
      </g>
    </svg>
  )
}

export default SvgComponent
